import React, { useCallback } from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from '@mui/material';
import { Disease, SUGGESTED_DISEASES } from '../types';
import { enrichDiseaseWithIndicationData } from '../utils/indications';

interface DiseaseSelectorProps {
  selectedDisease: Disease | null;
  onDiseaseSelect: (disease: Disease) => void;
}

export const DiseaseSelector: React.FC<DiseaseSelectorProps> = ({
  selectedDisease,
  onDiseaseSelect,
}) => {
  const handleChange = useCallback(async (event: SelectChangeEvent<string>) => {
    const selectedName = event.target.value;
    const disease = SUGGESTED_DISEASES.find((d) => d.name === selectedName);
    if (disease) {
      try {
        const enrichedDisease = await enrichDiseaseWithIndicationData(disease);
        onDiseaseSelect(enrichedDisease);
      } catch (error) {
        console.error('Error loading indication data:', error);
        onDiseaseSelect(disease);
      }
    }
  }, [onDiseaseSelect]);

  return (
    <Box sx={{ width: '100%', mb: 4 }}>
      <Typography variant="h6" gutterBottom>
        Select Disease/Indication
      </Typography>
      <FormControl fullWidth>
        <InputLabel id="disease-select-label">Disease/Indication</InputLabel>
        <Select
          labelId="disease-select-label"
          id="disease-select"
          value={selectedDisease?.name || ''}
          label="Disease/Indication"
          onChange={handleChange}
        >
          {SUGGESTED_DISEASES.map((disease) => (
            <MenuItem key={disease.name} value={disease.name}>
              {disease.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};
